<template>
    <div>

        <div class="row">
            <div class="col-8">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                        Payments of Expense

                    </span>
                </div>
            </div>
            <div class="col-4 add-button-section">
                <div style="display:inline">
                    <span @click="showModalTemp()"
                          style="
width: 30px;
height: 30px;
border-radius: 5px;
background-color: #212121;
color: white;
display: inline-block;
padding-left: 5px;
padding-right: 5px;
text-align: center;
cursor:pointer;
margin-right: 8px;
">
                        <i class="fa fa-plus" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <modal :scrollable="true" name="control-panel-add-form" @before-open="beforeOpen" height="auto" :minHeight="800" width="80%">

                        <div class="" id="contorlPanelAddModal" role="dialog">
                            <div class="">
                                <!-- Modal content-->
                                <div class="modal-content">
                                    <div style="padding:15px;">
                                        <div class="row">
                                            <div class="col-8">
                                                <div class="text-left section-title" style="padding: 5px;">
                                                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                                                        <template v-if="buildingId">
                                                            <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>
                                                        </template>
                                                        Form
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-4">
                                                <div class="text-right" style="padding: 5px;">
                                                    <a style="margin-left:6px;display:inline-block;" class="btn btn-table" @click.prevent="hide()"><i class="fas fa-times"></i></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">

                                            </div>
                                        </div>
                                        <creditnote-expenses-form :building-id="buildingId" :payment-id="expenseId" :amount="amount"></creditnote-expenses-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </modal>
                </div>
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
                <router-link class="btn btn-table" :to="{
          name: 'property',
          params: { buildingId: buildingId, buildingName: buildingName },
        }"><i class="fas fa-plus"></i></router-link>-->

                    <userMenu />
                </div>
            </div>

        </div>





        <div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col">Payment Date</th>
                        <th scope="col">Reference</th>
                        <th scope="col">Bank</th>
                        <th scope="col">Payment Type</th>
                        <th scope="col">Amount</th>


                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(expense, key, index) in payments"
                        :key="index"
                        class="clickable-row">
                        <td scope="row">{{ ++key }}</td>
                        <td>{{ customFormatterISO(expense.paidDate) }}</td>
                        <td>{{ expense.reference }}</td>
                        <td>{{ expense.bank }}</td>

                        <td>{{ getPaymentType(expense.paymentType) }}</td>
                        <td>{{ $filters.currency(expense.amount, "€") }}</td>


                        <!-- <td style="width:10%">
                        <a class="btn btn-edit" style="width:90px;" @click.prevent="editItem(expense)">Edit</a>
                    </td>
                    <td style="width:10%">
                        <a class="btn btn-delete" style="width:90px;" @click.prevent="deleteItem(expense)">Delete</a>
                    </td>-->
                    </tr>
                    <!--<tr style="color: black; font-size: 1.11em;">
                    <td scope="row" class="text-center"></td>

                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <td></td>
                    <td class="text-right">
                        <strong>Total Due :</strong>
                    </td>
                    <td class="text-left">
                        <strong>{{ $filters.currency(totalAmount, "€") }} </strong>
                    </td>
                </tr>-->
                </tbody>
            </table>
        </div>
        <div class="col-8">
            <div class="text-left section-title" style="padding: 5px;">
                <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                    Credit Note of Expense

                </span>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th scope="col">No</th>
                        <th scope="col">Credit Note No</th>
                        <th scope="col">Credit Note Date</th>
                        <th scope="col">Description</th>
                        <th scope="col">Amount</th>


                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(creditNote, key) in returns"
                        :key="creditNote"
                        class="clickable-row">
                        <td scope="row">{{ ++key }}</td>
                        <td>{{ creditNote.documentNumber }}</td>
                        <td>{{ customFormatterISO(creditNote.date) }}</td>

                        <td>{{ creditNote.description }}</td>


                        <td>{{ $filters.currency(creditNote.amount, "€") }}</td>


                        <!-- <td style="width:10%">
                        <a class="btn btn-edit" style="width:90px;" @click.prevent="editItem(expense)">Edit</a>
                    </td>
                    <td style="width:10%">
                        <a class="btn btn-delete" style="width:90px;" @click.prevent="deleteItem(expense)">Delete</a>
                    </td>-->
                    </tr>
                   
                </tbody>
            </table>
        </div>
        <div class="row" style="margin-top:30px;">
            <div class="col-12">
                <a @click="$router.go(-1)" class="btn btn-cancel" style="width:60px; display: block; margin-left: auto; margin-right: 0; margin-top: -30px">Back</a>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { format, parseISO } from "date-fns";
export default {
  data: function () {
    return {
      filter: "",
      additionalExpenses: [],
        buildingId: 0,
        expenseId:0,
     // buildingName: "",
      creditorId: 0,
      creditorName: "",
      totalAmount: 0,
      fromDate: new Date(new Date().getFullYear() - 1, 0, 1),
        toDate: new Date(),
        payments: [],
      returns:[]
    };
  },
  mounted() {
    this.buildingId = this.$route.params.buildingId;
   // this.buildingName = this.$route.params.buildingName;
    this.creditorId = this.$route.params.creditorId;
      this.payments = this.$route.params.payments;
      this.returns = this.$route.params.returns;
      this.expenseId = this.$route.params.expenseId;
      console.log(this.returns)
    //this.buildingName = this.$route.params.buildingName;
   // this.fetchStatement();
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    getCreditorExpenses() {
      var committees = this.additionalExpenses.filter((supplier) => {
        console.log(supplier);
        return supplier.expenseName.toLowerCase();
      });
      console.log(committees);
      return committees;
      },
      
  },
        methods: {
            getPaymentType(paymentType) {
                if (paymentType == 1)
                    return 'Cash'
                if (paymentType == 2)
                    return 'Checque'
                if (paymentType == 3)
                    return 'Bank Order'
            },
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/expensepayments/provider";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      // console.log(this.toDate)
      console.log(parseISO(format(this.toDate, "yyyy-MM-dd")));

      this.$http
        .post("/expensepayments/provider", {
          buildingId: this.buildingId,
          creditorId: this.creditorId,
          fromDate: parseISO(this.sendDateFormat(this.fromDate)),
          toDate: parseISO(this.sendDateFormat(this.toDate)),
        })
        .then((response) => {
          this.mute = false;
          console.log(response);
          //this.contacts = data.contacts;
          this.additionalExpenses = response.data.expensePayments;
          this.totalAmount = response.data.totalAmount;
        });

      /* this.$http.get(request, {
                        id : this.buildingId
                    }).then(({data}) => {
                                this.mute = false;
                                //this.contacts = data.contacts;
                            this.additionalExpenses = data.expensePayments;
                            console.log(this.additionalExpenses);*/
            },
            showModalTemp: function () {
                this.$modal.show("control-panel-add-form");
                //alert("Id " + expenseId + " month " + month);
                //this.isModalVisible = true;
            },
            show() {
                this.$modal.show("control-panel-add-form");
            },
            hide() {

                this.$modal.hide("control-panel-add-form");
            },
    editItem: function (item) {
      this.$router.push({
        name: "additionaldetail",
        params: {
          expenseId: item.id,
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },
    deleteItem: function destroy(item) {
      var r = confirm("Are you sure you want to delete additional expense?");
      if (r == true) {
        var _this = this;
        this.axios.delete("/additionalexpenses/" + item.id).then(function () {
          _this.fetchStatement();
          // _this.getVueItems();
          //_this.hasDeleted = false
        });
      }
    },
    customFormatter(date) {
      return format(date, "dd/MM/yyyy");
    },
    customFormatterISO(date) {
      return format(parseISO(date), "dd/MM/yyyy");
    },
    sendDateFormat(date) {
      return format(date, "yyyy-MM-dd");
    },
  },
};
</script>
